import React from 'react';
import PropTypes from 'prop-types';
import {Chip, Tooltip} from '@mui/material';

/**
 * @param {CheckboxWithOptionsListOfPREditors.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function ProtocolChip(props) {
    let color = '#FF0000';
    let bgColor = '#FFF0F0';

    if (props.protocol === 'cXML') {
        color = '#946635';
        bgColor = '#FFF5EB';
    } else if (props.protocol === 'OCI') {
        color = '#1560BD';
        bgColor = '#F0FFFF';
    }

    return (
        <Tooltip title={props.protocol === 'Undefined' ? 'You have to set either a username (for OCI), or From ID and To ID (cXML).' : ''}>
            <Chip
                label={props.protocol}
                variant="outlined"
                sx={{
                    color: color,
                    backgroundColor: bgColor,
                    borderColor: color,
                }}/>
        </Tooltip>
    );
}

ProtocolChip.propTypes = {
    protocol: PropTypes.oneOf(['cXML', 'OCI', 'Undefined']),
};
